<template>
  <v-container color="primary" class="pa-4" style="max-width: 1400px;">

    <!-- Toolbar -->
    <v-card class="elevation-2 mb-4">
      <v-toolbar flat color="white" class="border-bottom">
        <v-icon color="primary" class="mr-3">trending_up</v-icon>
        <v-toolbar-title class="headline font-weight-bold primary--text">
          Métricas de Operadores
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          depressed
          :loading="loadingCalculate"
          @click="calculateMetrics"
          class="mr-2"
        >
          <v-icon small class="mr-2">refresh</v-icon>
          Calcular Métricas
        </v-btn>
      </v-toolbar>

      <!-- Filtros -->
      <v-card-text class="pa-4">
        <v-layout row wrap class="mb-4">
          <v-flex xs12 sm6 md3 class="pr-2">
            <v-select
              v-model="filterOperatorType"
              :items="operatorTypeOptions"
              label="Tipo de Operador"
              outlined
              dense
              @change="loadMetrics"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 md3 class="pr-2">
            <v-menu
              ref="menuStart"
              v-model="menuStart"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  v-model="filterStartDate"
                  label="Fecha Inicio"
                  outlined
                  dense
                  readonly
                  prepend-icon="calendar_today"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filterStartDate"
                @input="menuStart = false; loadMetrics()"
                color="primary"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md3 class="pr-2">
            <v-menu
              ref="menuEnd"
              v-model="menuEnd"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  v-model="filterEndDate"
                  label="Fecha Fin"
                  outlined
                  dense
                  readonly
                  prepend-icon="calendar_today"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filterEndDate"
                @input="menuEnd = false; loadMetrics()"
                color="primary"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-btn
              color="primary"
              outlined
              block
              @click="resetFilters"
            >
              Limpiar Filtros
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <!-- Sección: Disponibilidad de Choferes -->
    <v-card class="elevation-2 mb-4">
      <v-toolbar flat color="white" class="border-bottom">
        <v-icon color="primary" class="mr-3">person_pin</v-icon>
        <v-toolbar-title class="subheading font-weight-bold primary--text">
          Disponibilidad de Choferes
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          icon
          small
          :loading="loadingAvailableDrivers"
          @click="loadAvailableDrivers"
          title="Actualizar disponibilidad"
        >
          <v-icon small>refresh</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-4">
        <v-layout row wrap class="mb-4">
          <v-flex xs12 sm6 md3 class="pr-2">
            <v-menu
              ref="menuAvailStart"
              v-model="menuAvailStart"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  v-model="availabilityDate"
                  label="Fecha"
                  outlined
                  dense
                  readonly
                  prepend-icon="calendar_today"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="availabilityDate"
                @input="menuAvailStart = false; loadAvailableDrivers()"
                color="primary"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6 md3 class="pr-2">
            <v-text-field
              v-model="availabilityTime"
              label="Hora"
              outlined
              dense
              type="time"
              @change="loadAvailableDrivers"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md3 class="pr-2">
            <v-text-field
              v-model.number="estimatedDuration"
              label="Duración Estimada (horas)"
              outlined
              dense
              type="number"
              min="1"
              step="0.5"
              @change="loadAvailableDrivers"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-btn
              color="primary"
              block
              depressed
              :loading="loadingAvailableDrivers"
              @click="loadAvailableDrivers"
            >
              Buscar Disponibles
            </v-btn>
          </v-flex>
        </v-layout>

        <!-- Tabla de Choferes Disponibles -->
        <v-divider class="my-4"></v-divider>
        <div class="subheading font-weight-bold primary--text mb-3">
          Choferes Disponibles ({{ availableDrivers.length }})
        </div>
        <v-data-table
          :headers="availableDriversHeaders"
          :items="availableDrivers"
          :loading="loadingAvailableDrivers"
          class="elevation-0"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id_usuario_name }}</td>
            <td>{{ props.item.id_usuario_email }}</td>
            <td>
              <span v-if="props.item.position && props.item.position !== 'null'">{{ props.item.position }}</span>
              <span v-else class="grey--text">—</span>
            </td>
            <td class="text-xs-center">
              <span v-if="props.item.employee_number" class="font-weight-bold">{{ props.item.employee_number }}</span>
              <span v-else class="grey--text">—</span>
            </td>
            <td class="text-xs-center">
              <v-chip
                :color="props.item.is_driver ? 'success' : 'grey'"
                text-color="white"
                small
              >
                {{ props.item.is_driver ? 'Sí' : 'No' }}
              </v-chip>
            </td>
            <td class="text-xs-center">
              <v-btn
                icon
                small
                color="primary"
                @click="openDriverAssignmentDialog(props.item)"
                title="Seleccionar chofer"
              >
                <v-icon small>check_circle</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Dashboard - Top y Bottom Performers -->
    <v-layout row wrap v-if="dashboardData" class="mb-4">
      <!-- Top Performers -->
      <v-flex xs12 md6 class="pr-2 mb-4">
        <v-card class="elevation-2">
          <v-toolbar flat color="success lighten-4" class="border-bottom">
            <v-icon color="success" class="mr-2">trending_up</v-icon>
            <v-toolbar-title class="subheading font-weight-bold success--text">
              Mejores Operadores
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4">
            <v-list dense v-if="dashboardData.top_performers && dashboardData.top_performers.length > 0">
              <v-list-item v-for="(op, idx) in dashboardData.top_performers" :key="idx" @click="openOperatorDetail(op)">
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    {{ idx + 1 }}. {{ op.operator_name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Efficiency: <strong class="success--text">{{ op.efficiency_score.toFixed(2) }}%</strong>
                    | Viajes: {{ op.total_trips }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon small color="primary" @click.stop="openOperatorDetail(op)">
                    <v-icon small>chevron_right</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-else class="text-center pa-4 grey--text">
              Sin datos disponibles
            </div>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- Bottom Performers -->
      <v-flex xs12 md6 class="mb-4">
        <v-card class="elevation-2">
          <v-toolbar flat color="warning lighten-4" class="border-bottom">
            <v-icon color="warning" class="mr-2">trending_down</v-icon>
            <v-toolbar-title class="subheading font-weight-bold warning--text">
              Operadores con Menor Desempeño
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="pa-4">
            <v-list dense v-if="dashboardData.bottom_performers && dashboardData.bottom_performers.length > 0">
              <v-list-item v-for="(op, idx) in dashboardData.bottom_performers" :key="idx" @click="openOperatorDetail(op)">
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    {{ idx + 1 }}. {{ op.operator_name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Efficiency: <strong class="warning--text">{{ op.efficiency_score.toFixed(2) }}%</strong>
                    | Viajes: {{ op.total_trips }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon small color="primary" @click.stop="openOperatorDetail(op)">
                    <v-icon small>chevron_right</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <div v-else class="text-center pa-4 grey--text">
              Sin datos disponibles
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Summary Stats -->
    <v-layout row wrap v-if="dashboardData && dashboardData.summary_stats" class="mb-4">
      <v-flex xs12 sm6 md3 class="pr-2 mb-2">
        <v-card class="elevation-1">
          <v-card-text class="text-center">
            <div class="headline font-weight-bold primary--text">
              {{ dashboardData.summary_stats.average_completion_rate.toFixed(2) }}%
            </div>
            <div class="caption grey--text">Tasa Completación Promedio</div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md3 class="pr-2 mb-2">
        <v-card class="elevation-1">
          <v-card-text class="text-center">
            <div class="headline font-weight-bold primary--text">
              {{ dashboardData.summary_stats.average_efficiency_score.toFixed(2) }}%
            </div>
            <div class="caption grey--text">Efficiency Score Promedio</div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md3 class="pr-2 mb-2">
        <v-card class="elevation-1">
          <v-card-text class="text-center">
            <div class="headline font-weight-bold primary--text">
              {{ dashboardData.summary_stats.total_trips_tracked }}
            </div>
            <div class="caption grey--text">Total Viajes Registrados</div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm6 md3 class="pr-2 mb-2">
        <v-card class="elevation-1">
          <v-card-text class="text-center">
            <div class="headline font-weight-bold primary--text">
              {{ dashboardData.summary_stats.average_on_time_rate.toFixed(2) }}%
            </div>
            <div class="caption grey--text">Tasa Puntualidad Promedio</div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- Tabla de Métricas -->
    <v-card class="elevation-2">
      <v-toolbar flat color="white" class="border-bottom">
        <v-toolbar-title class="subheading font-weight-bold primary--text">
          Métricas por Operador
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <span class="caption grey--text">{{ metrics.length }} operadores</span>
      </v-toolbar>
      <v-data-table
        :headers="tableHeaders"
        :items="metrics"
        :loading="loadingMetrics"
        class="elevation-0"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-chip
              :color="props.item.operator_type === 'INTERNO' ? 'success' : 'info'"
              text-color="white"
              small
            >
              {{ props.item.operator_type }}
            </v-chip>
          </td>
          <td>{{ props.item.operator_name }}</td>
          <td class="text-xs-center">{{ props.item.total_trips }}</td>
          <td class="text-xs-center">{{ props.item.completed_trips }}</td>
          <td class="text-xs-center">{{ props.item.completion_rate.toFixed(2) }}%</td>
          <td class="text-xs-center">{{ props.item.on_time_rate.toFixed(2) }}%</td>
          <td class="text-xs-center">
            <div class="d-flex align-center justify-center">
              <v-progress-circular
                :value="props.item.efficiency_score"
                :color="getEfficiencyColor(props.item.efficiency_score)"
                size="40"
              >
                <span class="caption font-weight-bold">
                  {{ props.item.efficiency_score.toFixed(1) }}
                </span>
              </v-progress-circular>
            </div>
          </td>
          <td class="text-xs-center">
            <v-btn
              icon
              small
              color="primary"
              @click="openOperatorDetail(props.item)"
              title="Ver detalles"
            >
              <v-icon small>info</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <!-- Modal Detalles de Operador -->
    <v-dialog v-model="dialogOperatorDetail" max-width="700px" persistent>
      <v-card v-if="selectedOperator">
        <!-- Header con gradiente -->
        <v-toolbar color="primary" dark flat>
          <div>
            <div class="headline font-weight-bold">{{ selectedOperator.operator_name }}</div>
            <div class="caption">{{ selectedOperator.company_name }}</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogOperatorDetail = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Información básica -->
        <v-card-text class="pa-6">
          <v-layout row wrap>
            <!-- Badges de tipo y período -->
            <v-flex xs12 class="mb-4">
              <v-chip
                :color="selectedOperator.operator_type === 'INTERNO' ? 'success' : 'info'"
                text-color="white"
                class="mr-2"
              >
                <v-icon left small>{{ selectedOperator.operator_type === 'INTERNO' ? 'person' : 'business' }}</v-icon>
                {{ selectedOperator.operator_type }}
              </v-chip>
              <v-chip outlined small>
                <v-icon left small>date_range</v-icon>
                {{ selectedOperator.period_label }}
              </v-chip>
            </v-flex>

            <!-- KPIs principales -->
            <v-flex xs12 class="mb-4">
              <div class="subheading font-weight-bold mb-3 primary--text">Indicadores Clave</div>
              <v-layout row wrap>
                <v-flex xs6 sm3 class="pa-2">
                  <v-card flat class="elevation-1 pa-3 text-center">
                    <div class="title font-weight-bold primary--text">{{ selectedOperator.efficiency_score.toFixed(1) }}%</div>
                    <div class="caption">Eficiencia</div>
                  </v-card>
                </v-flex>
                <v-flex xs6 sm3 class="pa-2">
                  <v-card flat class="elevation-1 pa-3 text-center">
                    <div class="title font-weight-bold success--text">{{ selectedOperator.completion_rate.toFixed(1) }}%</div>
                    <div class="caption">Completación</div>
                  </v-card>
                </v-flex>
                <v-flex xs6 sm3 class="pa-2">
                  <v-card flat class="elevation-1 pa-3 text-center">
                    <div class="title font-weight-bold warning--text">{{ selectedOperator.on_time_rate.toFixed(1) }}%</div>
                    <div class="caption">Puntualidad</div>
                  </v-card>
                </v-flex>
                <v-flex xs6 sm3 class="pa-2">
                  <v-card flat class="elevation-1 pa-3 text-center">
                    <div class="title font-weight-bold error--text">{{ selectedOperator.cancellation_rate.toFixed(1) }}%</div>
                    <div class="caption">Cancelación</div>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>

            <!-- Detalles de viajes -->
            <v-flex xs12 class="mb-4">
              <v-divider class="my-3"></v-divider>
              <div class="subheading font-weight-bold mb-3 primary--text">Detalles de Viajes</div>
              <v-layout row wrap>
                <v-flex xs6 sm4 class="pa-2">
                  <div class="text-xs-center">
                    <div class="display-1 font-weight-bold primary--text">{{ selectedOperator.total_trips }}</div>
                    <div class="caption">Total de Viajes</div>
                  </div>
                </v-flex>
                <v-flex xs6 sm4 class="pa-2">
                  <div class="text-xs-center">
                    <div class="display-1 font-weight-bold success--text">{{ selectedOperator.completed_trips }}</div>
                    <div class="caption">Completados</div>
                  </div>
                </v-flex>
                <v-flex xs6 sm4 class="pa-2">
                  <div class="text-xs-center">
                    <div class="display-1 font-weight-bold error--text">{{ selectedOperator.cancelled_trips }}</div>
                    <div class="caption">Cancelados</div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>

            <!-- Tiempos promedio -->
            <v-flex xs12 class="mb-4">
              <v-divider class="my-3"></v-divider>
              <div class="subheading font-weight-bold mb-3 primary--text">Tiempos Promedio</div>
              <v-layout row wrap>
                <v-flex xs12 sm6 v-if="selectedOperator.avg_loading_time >= 0" class="mb-3">
                  <div class="caption font-weight-bold mb-1">Tiempo de Carga</div>
                  <v-progress-linear
                    :value="Math.min(selectedOperator.avg_loading_time, 100)"
                    color="info"
                    height="8"
                    class="rounded"
                  ></v-progress-linear>
                  <div class="caption">{{ selectedOperator.avg_loading_time.toFixed(1) }} minutos</div>
                </v-flex>
                <v-flex xs12 sm6 v-if="selectedOperator.avg_queue_time >= 0" class="mb-3">
                  <div class="caption font-weight-bold mb-1">Tiempo en Cola</div>
                  <v-progress-linear
                    :value="Math.min(selectedOperator.avg_queue_time, 100)"
                    color="warning"
                    height="8"
                    class="rounded"
                  ></v-progress-linear>
                  <div class="caption">{{ selectedOperator.avg_queue_time.toFixed(1) }} minutos</div>
                </v-flex>
              </v-layout>
            </v-flex>

            <!-- Uso de flota -->
            <v-flex xs12 v-if="selectedOperator.vehicles_used || selectedOperator.internal_fleet_usage">
              <v-divider class="my-3"></v-divider>
              <div class="subheading font-weight-bold mb-3 primary--text">Información de Flota</div>
              <v-layout row wrap>
                <v-flex xs6 v-if="selectedOperator.vehicles_used" class="mb-2">
                  <v-chip small outlined>
                    <v-icon left small>directions_car</v-icon>
                    {{ selectedOperator.vehicles_used }} vehículos utilizados
                  </v-chip>
                </v-flex>
                <v-flex xs6 v-if="selectedOperator.internal_fleet_usage >= 0" class="mb-2">
                  <v-chip small outlined>
                    <v-icon left small>assessment</v-icon>
                    {{ selectedOperator.internal_fleet_usage.toFixed(1) }}% flota interna
                  </v-chip>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions class="pa-6 justify-end">
          <v-btn color="primary" depressed @click="dialogOperatorDetail = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal Asignación de Chofer -->
    <v-dialog v-model="dialogDriverAssignment" max-width="500px">
      <v-card v-if="selectedDriver">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>Asignar Chofer</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogDriverAssignment = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-6">
          <v-layout column>
            <v-flex class="mb-4">
              <div class="subheading font-weight-bold mb-3">Información del Chofer</div>
              <v-card flat class="pa-4 elevation-1 mb-4">
                <div class="body-2 mb-2">
                  <strong>Nombre:</strong> {{ selectedDriver.id_usuario_name }}
                </div>
                <div class="body-2 mb-2">
                  <strong>Email:</strong> {{ selectedDriver.id_usuario_email }}
                </div>
                <div class="body-2 mb-2" v-if="selectedDriver.position && selectedDriver.position !== 'null'">
                  <strong>Posición:</strong> {{ selectedDriver.position }}
                </div>
                <div class="body-2 mb-2" v-if="selectedDriver.employee_number">
                  <strong>Empleado #:</strong> {{ selectedDriver.employee_number }}
                </div>
                <div class="body-2">
                  <strong>Clasificación:</strong>
                  <v-chip
                    :color="selectedDriver.is_driver ? 'success' : 'grey'"
                    text-color="white"
                    small
                    class="ml-2"
                  >
                    {{ selectedDriver.is_driver ? 'Chofer Certificado' : 'No es Chofer' }}
                  </v-chip>
                </div>
              </v-card>

              <div class="subheading font-weight-bold mb-3">Información de la Ventana</div>
              <v-card flat class="pa-4 elevation-1">
                <div class="body-2 mb-2">
                  <strong>Fecha:</strong> {{ availabilityDate }}
                </div>
                <div class="body-2 mb-2">
                  <strong>Hora:</strong> {{ availabilityTime }}
                </div>
                <div class="body-2">
                  <strong>Duración Estimada:</strong> {{ estimatedDuration }} hora(s)
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions class="pa-4 justify-end">
          <v-btn color="grey" text @click="dialogDriverAssignment = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" depressed @click="assignDriver">
            <v-icon left small>check</v-icon>
            Asignar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'OperatorMetrics',
  data: () => ({
    metrics: [],
    dashboardData: null,
    selectedOperator: null,
    dialogOperatorDetail: false,
    loadingMetrics: false,
    loadingCalculate: false,
    filterOperatorType: 'TODOS',
    filterStartDate: '',
    filterEndDate: '',
    menuStart: false,
    menuEnd: false,
    operatorTypeOptions: [
      { text: 'Todos', value: 'TODOS' },
      { text: 'Internos', value: 'INTERNO' },
      { text: 'Externos', value: 'EXTERNO' }
    ],
    tableHeaders: [
      { text: 'Tipo', value: 'operator_type', width: '100px' },
      { text: 'Operador', value: 'operator_name' },
      { text: 'Viajes', value: 'total_trips', align: 'center', width: '80px' },
      { text: 'Completados', value: 'completed_trips', align: 'center', width: '100px' },
      { text: '% Completación', value: 'completion_rate', align: 'center' },
      { text: '% Puntualidad', value: 'on_time_rate', align: 'center' },
      { text: 'Efficiency Score', value: 'efficiency_score', align: 'center' },
      { text: 'Acciones', value: 'actions', align: 'center', width: '80px', sortable: false }
    ],
    availableDrivers: [],
    loadingAvailableDrivers: false,
    availabilityDate: '',
    availabilityTime: '09:00',
    estimatedDuration: 2,
    menuAvailStart: false,
    availableDriversHeaders: [
      { text: 'Nombre', value: 'id_usuario_name' },
      { text: 'Email', value: 'id_usuario_email' },
      { text: 'Posición', value: 'position' },
      { text: 'Empleado #', value: 'employee_number' },
      { text: 'Chofer', value: 'is_driver', width: '80px', align: 'center' },
      { text: 'Acciones', value: 'actions', align: 'center', width: '80px', sortable: false }
    ],
    dialogDriverAssignment: false,
    selectedDriver: null
  }),
  computed: {
    ...mapGetters(['getProfile'])
  },
  created() {
    this.initializeDates()
    this.loadMetrics()
  },
  watch: {
    filterStartDate() {
      this.loadMetrics()
    },
    filterEndDate() {
      this.loadMetrics()
    },
    filterOperatorType() {
      this.loadMetrics()
    }
  },
  methods: {
    initializeDates() {
      const today = new Date()
      const monthStart = new Date(today.getFullYear(), today.getMonth(), 1)

      this.filterEndDate = today.toISOString().split('T')[0]
      this.filterStartDate = monthStart.toISOString().split('T')[0]
      this.availabilityDate = today.toISOString().split('T')[0]
    },
    calculateMetrics() {
      if (!this.getProfile || !this.getProfile.id_company) {
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', 'Error: Perfil de usuario no disponible')
        return
      }

      this.loadingCalculate = true
      const params = new URLSearchParams()
      params.append('company_id', this.getProfile.id_company)
      params.append('operator_type', this.filterOperatorType)

      // Agregar filtros de fecha si existen
      if (this.filterStartDate) {
        params.append('start_date', this.filterStartDate)
      }
      if (this.filterEndDate) {
        params.append('end_date', this.filterEndDate)
      }

      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/shipments/operator-metrics/calculate/?' + params.toString(),
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }

      axios(config)
        .then(response => {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_color', 'success')
          this.$store.commit('snackbar_change_message', response.data.message || 'Métricas calculadas exitosamente')
          this.loadMetrics()
        })
        .catch(error => {
          console.log('Error calculando métricas:', error)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_color', 'error')
          const errorMsg = (error.response && error.response.data && error.response.data.message) || 'Error al calcular métricas'
          this.$store.commit('snackbar_change_message', errorMsg)
        })
        .finally(() => {
          this.loadingCalculate = false
        })
    },
    loadMetrics() {
      this.loadingMetrics = true
      const params = new URLSearchParams()
      params.append('operator_type', this.filterOperatorType)

      if (this.filterStartDate) {
        params.append('start_date', this.filterStartDate)
      }
      if (this.filterEndDate) {
        params.append('end_date', this.filterEndDate)
      }
      if (this.getProfile && this.getProfile.id_company) {
        params.append('company_id', this.getProfile.id_company)
      }

      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/shipments/operator-metrics/list/?' + params.toString(),
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }

      axios(config)
        .then(response => {
          console.log('Respuesta de métricas:', response.data)
          const metricsData = Array.isArray(response.data) ? response.data : (response.data.results || [])
          this.metrics = metricsData
          console.log('Métricas asignadas:', this.metrics)
          console.log('Cantidad de métricas:', this.metrics.length)
          console.log('Primera métrica:', this.metrics[0])
          if (this.getProfile && this.getProfile.id_company) {
            this.loadDashboard()
          }
        })
        .catch(error => {
          console.log('Error cargando métricas:', error)
          this.metrics = []
        })
        .finally(() => {
          this.loadingMetrics = false
          console.log('loadingMetrics puesto en false, metrics ahora:', this.metrics)
        })
    },
    loadDashboard() {
      if (!this.getProfile || !this.getProfile.id_company) {
        console.log('getProfile no está disponible aún')
        return
      }

      const params = new URLSearchParams()
      params.append('company_id', this.getProfile.id_company)

      if (this.filterStartDate) {
        params.append('start_date', this.filterStartDate)
      }
      if (this.filterEndDate) {
        params.append('end_date', this.filterEndDate)
      }

      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/shipments/operator-metrics/dashboard/?' + params.toString(),
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }

      axios(config)
        .then(response => {
          console.log('Respuesta de dashboard:', response.data)
          this.dashboardData = response.data
          console.log('Dashboard asignado:', this.dashboardData)
        })
        .catch(error => {
          console.log('Error cargando dashboard:', error)
        })
    },
    openOperatorDetail(operator) {
      this.selectedOperator = operator
      this.dialogOperatorDetail = true
    },
    getEfficiencyColor(score) {
      if (score >= 85) return 'success'
      if (score >= 70) return 'warning'
      return 'error'
    },
    resetFilters() {
      this.filterOperatorType = 'TODOS'
      this.initializeDates()
      this.loadMetrics()
    },
    loadAvailableDrivers() {
      // Validación de fecha y hora
      if (!this.availabilityDate) {
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', 'Por favor selecciona una fecha')
        return
      }

      if (!this.availabilityTime) {
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', 'Por favor selecciona una hora')
        return
      }

      // Validación de perfil
      if (!this.getProfile || !this.getProfile.id_company) {
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', 'Error: No se pudo cargar el perfil del usuario')
        return
      }

      this.loadingAvailableDrivers = true
      const params = new URLSearchParams()
      params.append('company_id', this.getProfile.id_company)
      params.append('window_date', this.availabilityDate)
      params.append('window_time', this.availabilityTime)
      params.append('estimated_duration_hours', this.estimatedDuration)

      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/shipments/availability/drivers/list/?' + params.toString(),
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }

      axios(config)
        .then(response => {
          console.log('Respuesta choferes:', response.data)
          console.log('Drivers array:', response.data.drivers)
          this.availableDrivers = response.data.drivers || []
          console.log('availableDrivers asignados:', this.availableDrivers)
          console.log('availableDrivers length:', this.availableDrivers.length)
        })
        .catch(error => {
          console.log('Error cargando choferes disponibles:', error)
          this.availableDrivers = []
        })
        .finally(() => {
          this.loadingAvailableDrivers = false
          console.log('loadingAvailableDrivers false, drivers:', this.availableDrivers)
        })
    },
    openDriverAssignmentDialog(driver) {
      this.selectedDriver = driver
      this.dialogDriverAssignment = true
    },
    assignDriver() {
      if (!this.selectedDriver) {
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'No hay chofer seleccionado')
        return
      }

      this.$store.commit('snackbar_activate_true')
      this.$store.commit('snackbar_change_message', `✓ Chofer ${this.selectedDriver.id_usuario_name} asignado para ${this.availabilityDate} a las ${this.availabilityTime}`)

      this.dialogDriverAssignment = false
      this.selectedDriver = null
    }
  }
}
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #e0e0e0;
}

.table-row-hover {
  transition: background-color 0.2s ease;
}

.table-row-hover:hover {
  background-color: #f5f5f5 !important;
}
</style>
